import { Menu } from '../assets/icons';
import { Constants } from '../utils';

export const MENU_ADMIN = [
  {
    name: 'Inicio',
    href: '/',
    icon: Menu.Menu1,
    iconActive: Menu.Menu1Active,
  },
  {
    name: 'Configuración de ruta',
    href: '/route-config',
    icon: Menu.Menu3,
    iconActive: Menu.Menu3Active,
  },
  {
    name: 'Facturación por tipo de persona',
    href: '/billing/owner',
    icon: Menu.Menu5,
    iconActive: Menu.Menu5Active,
    nested: [
      {
        name: 'Facturación por tipo de persona',
        href: '/billing/owner',
      },
      {
        name: 'Facturación por tipo de persona',
        href: '/billing/driver',
      },
    ],
  },
  {
    name: 'Facturación cliente',
    breadcumb: 'Facturación Clientes',
    href: '/billing/client',
    icon: Menu.Menu9,
    iconActive: Menu.Menu9Active,
  },
  {
    name: 'Usuarios',
    href: '/users',
    icon: Menu.Menu6,
    iconActive: Menu.Menu6Active,
  },
  {
    name: 'Vehículos',
    href: '/vehicles',
    icon: Menu.Menu11,
    iconActive: Menu.Menu11Active,
    nested: [
      {
        name: 'Nuevo vehículo',
        href: '/vehicles/create',
      },
      {
        name: 'Editar vehículo',
        href: '/vehicles/:id/edit',
      },
    ],
  },
  {
    name: 'Tasa de cambio',
    href: '/conversion',
    icon: Menu.Menu10,
    iconActive: Menu.Menu10Active,
  },
  {
    name: 'Plan de mantenimiento',
    href: '/maintenance-plan',
    icon: Menu.Menu8,
    iconActive: Menu.Menu8Active,
    nested: [
      {
        name: 'Nueva categoría',
        href: '/maintenance-plan/create',
      },
      {
        name: 'Editar categoría',
        href: '/maintenance-plan/:id/edit',
      },
    ],
  },
  {
    name: 'Reportes',
    icon: Menu.Menu4,
    iconActive: Menu.Menu4Active,
    modules: [
      {
        name: 'Facturación por tipo de persona',
        href: '/report/billing',
      },
      {
        name: 'Facturación por ruta',
        breadcumb: 'Reporte facturación por ruta',
        href: '/report/billing/route',
      },
      {
        name: 'Relación general de pago',
        breadcumb: 'Reporte Relación General de Pagos',
        href: '/report/billing/relation',
      },
      {
        name: 'Reporte de Utilidad y Rentabilidad',
        href: '/report/billing/profit',
      },
      {
        name: 'Incidencias',
        href: '/404',
      },
    ],
  },
];

export const MENU_MODERATOR = [
  {
    name: 'Inicio',
    href: '/',
    icon: Menu.Menu1,
    iconActive: Menu.Menu1Active,
  },
  {
    name: 'Gestión de mantenimientos',
    href: '/maintenance',
    icon: Menu.Menu2,
    iconActive: Menu.Menu2Active,
    profile: [
      Constants.MODERATOR_TYPE.COORDINATOR,
    ],
    nested: [
      {
        name: 'Gestión de mantenimientos',
        href: '/maintenance',
      },
      {
        name: 'Gestión de mantenimientos',
        href: '/maintenance/plan',
      },
      {
        name: 'Gestión de mantenimientos',
        href: '/maintenance/history',
      },
      {
        name: 'Reportar mantenimiento',
        href: '/maintenance/report/:id',
      },
    ],
  },
  {
    name: 'Plan de mantenimiento',
    href: '/maintenance-plan',
    icon: Menu.Menu8,
    iconActive: Menu.Menu8Active,
    profile: [
      Constants.MODERATOR_TYPE.COORDINATOR,
    ],
    nested: [
      {
        name: 'Nueva categoría',
        href: '/maintenance-plan/create',
      },
      {
        name: 'Editar categoría',
        href: '/maintenance-plan/:id/edit',
      },
    ],
  },
  {
    name: 'Reportes',
    icon: Menu.Menu4,
    iconActive: Menu.Menu4Active,
    profile: [
      Constants.MODERATOR_TYPE.COORDINATOR,
    ],
    modules: [
      {
        name: 'Fallas de vehículos',
        href: '/report/failures',
        nested: [
          {
            name: 'Fallas del vehículo',
            href: '/report/failures/:plaque',
          }
        ],
      },
    ],
  },
  {
    name: 'Cartelera',
    href: '/panel',
    icon: Menu.Menu2,
    iconActive: Menu.Menu2Active,
    profile: [
      Constants.MODERATOR_TYPE.SUPERVISOR,
    ],
  },
  {
    name: 'Reportes',
    icon: Menu.Menu4,
    iconActive: Menu.Menu4Active,
    profile: [
      Constants.MODERATOR_TYPE.SUPERVISOR,
    ],
    modules: [
      {
        name: 'Viajes finalizados',
        breadcumb: 'Viajes Realizados',
        href: '/report/finished',
      },
      {
        name: 'Conductores',
        breadcumb: 'Reporte de conductores',
        href: '/report/drivers',
      },
      {
        name: 'Incidencias',
        href: '/report/incidents',
      },
    ],
  },
];

export const MENU_OWNER = [
  {
    name: 'Inicio',
    href: '/',
    icon: Menu.Menu1,
    iconActive: Menu.Menu1Active,
  },
  {
    name: 'Reportes',
    icon: Menu.Menu4,
    iconActive: Menu.Menu4Active,
    modules: [
      {
        name: 'Comisiones propietario',
        breadcumb: 'Comisiones',
        href: '/report/commissions',
      },
      {
        name: 'Fallas de vehículos',
        href: '/report/failures',
        nested: [
          {
            name: 'Fallas del vehículo',
            href: '/report/failures/:plaque',
          }
        ],
      },
      {
        name: 'Reporte de Mantenimiento',
        href: '/report/maintenance',
      },
      {
        name: 'Incidencias',
        breadcumb: 'Reporte de Incidencias y Desviaciones',
        href: '/report/incidents',
      },
    ],
  },
];
